import { addSocketDispatcherMiddleware } from 'modules/webSocket/state';

import { eventSocketDispatcherMiddleware } from './eventSocketDispatcherMiddleware';

export * from './actions';
export * from './constants';
export * from './eventSlice';
export * from './eventSlice.actions';
export * from './listeners';
export * from './selectors';
export * from './types';

addSocketDispatcherMiddleware(eventSocketDispatcherMiddleware);
